import productDiscoveryLandscapeImg from "../../../assets/img/product-gg-discovery-landscape.png"
import productDiscoveryLandscapeImgWebp from "../../../assets/img/product-gg-discovery-landscape.webp"

const DiscoveryBuried = () => (
    <section id="discovery-buried">
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center pb-4">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-bg-solid-blue gg-border-radius text-white">
                    <div className="row justify-content-center align-items-center mb-4">
                        <div className="col-md-10 text-center">
                            <h1>A Discovery Buried in the Noise</h1>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-items-center text-center">
                            <picture>
                                <source srcSet={productDiscoveryLandscapeImgWebp} type="image/webp" />
                                <img className="img-fluid gg-border-radius" src={productDiscoveryLandscapeImg} loading="lazy" />
                            </picture>                            
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                            <p>It turns out that what Dr Hart shared with me wasn’t a new pill, or a miracle food, or some restrictive diet plan that makes you miserable.</p>
                            <p>It was something else entirely.</p>
                            <p>Something buried so deep under the avalanche of type 2 diabetes "advice" that most doctors don’t even realise it exists.</p>
                            <p className="fw-bold">What struck me most wasn’t just how effective it was. It was how simple it felt.</p>
                            <p className="fw-bold">Like flipping a switch, my body had forgotten about.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center mt-5">
                        <div className="col-md-10 align-items-center text-md-start text-center">
                            <p>
                                It was simply a specific shift. A <b>quiet recalibration.</b><br />
                                One that made everything else: my energy, my sugar levels, my mental clarity... start falling into place.
                            </p>
                            <p>It sounded too good to be true.</p>
                            <p>
                                But my body didn’t lie.<br />
                                And neither did the thousands of others who experienced the same.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default DiscoveryBuried;